import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import { Link } from 'react-router';
import {
  loadFestivalSponsorshipCategories
} from '../actions';
import DocumentMeta from 'react-document-meta';
import { isEmpty } from 'lodash/lang';
import FestivalSponsorSidebar from '../components/festival/sponsorship/FestivalSponsorSidebar';
import FestivalOurSponsorLogos from '../components/festival/sponsorship/FestivalOurSponsorLogos';
import Disclaimer from '../components/festival/Disclaimer';


class FestivalOurSponsors extends Component {
  constructor(props) {
    super(props);
  }

  state = {
    sideBarNavOpen: false,
    page: 'default',
    sidebarLinkActive: 'default',
    isTapped: false
  }

  opensideBarNav = (e) => {
    this.setState({ sideBarNavOpen: !this.state.sideBarNavOpen })
  }

  handleTap = (e) => {
    e.preventDefault()
    this.setState({isTapped: !this.state.isTapped})
  }

  parentSetActiveAnchorState = (slug) => {
    this.props.push('/girls-festival/our-sponsors#' + slug)
    this.setState({sidebarLinkActive: slug, isTapped: !this.state.isTapped})
  }

  componentWillMount() {
    this.props.loadFestivalSponsorshipCategories({show_logo:true});
  }

  componentDidMount() {
    window.scrollTo(0, 0);
  }

  render() {
    if (!this.props.festivalSponsorshipCategories.isLoaded) {
      return <span />;
    }

    let sponsorshipCategories = this.props.festivalSponsorshipCategories;
    let sponsorshipList;
    let sponsorshipCategorySponsorsList;
    let sponsorList;
    let categoryHeader;

    let caretIcon;
    let tapStatus;

    // Used for mobile menu
    if (this.state.isTapped) {
      tapStatus = 'is-tapped'
      caretIcon = <i className="fa fa-chevron-up"></i>
    } else {
      tapStatus = '';
      caretIcon = <i className="fa fa-chevron-down"></i>
    }

    let sponsorCategoryHeader = '';

    sponsorshipCategorySponsorsList = sponsorshipCategories.map((category, index) => {
      sponsorCategoryHeader = category.sponsor_category_name.toUpperCase();
      return <div className="festivalOurSponsors-categoryMasterWrapper">
                <div className="festivalOurSponsors-categoryWrapperOuter">
                  <div className="festivalOurSponsors-categoryWrapperInner"><a name={category.slug}>{sponsorCategoryHeader}</a></div>
                </div>

                <FestivalOurSponsorLogos
                  sponsors = {category.sponsors}
                />
            </div>
    });




    return(
      <div>
        <div className="festivalHome-bannerWrapper">
          <a href="/girls-festival/tickets"><img className="desktop" src="/images/festival/home/gf_banner_desktop6.jpg" /></a>

          <a href="/girls-festival/tickets"><img className="mobile" src="/images/festival/home/gf_banner_mobile6.jpg" /></a>
        </div>


        <div id="mobile-subnav-wrapper">
          <div id="mobile-subnav" className="subnavigation">

            <div onClick={this.handleTap} className="sub-menu-icon">
              <a href="#">Our Sponsors {caretIcon}</a>
            </div>
            <FestivalSponsorSidebar
              festivalSponsorshipCategories={this.props.festivalSponsorshipCategories}
              parentSetActiveAnchorState={this.parentSetActiveAnchorState}
              tapStatus={tapStatus}
              handleTap={this.handleTap}
            />

          </div>
        </div>


        <div className="content-wrapper">

          <div className="festivalProgram2ColWrapper">
            <div className="festivalProgramSidebar-wrapper festivalSidebar-wrapper">
              <FestivalSponsorSidebar
                festivalSponsorshipCategories={this.props.festivalSponsorshipCategories}
                parentSetActiveAnchorState={this.parentSetActiveAnchorState}
              />
            </div>

            <div className="festivalProgram-bodyWrapper festivalMainBody-wrapper">

              <h1 className="page-heading">Thank you to our current sponsors</h1>
              <p>The Girls' Festival is made possible through the generous support of sponsors, donors and partners. A big thank you to all supporters...</p>

              <div className="sponsorshipCategorySponsorsListWrapper">{sponsorshipCategorySponsorsList}</div>

              <Disclaimer hasAsterisk = 'false' />

            </div>
          </div>


        </div>

      </div>

    );
  }
};

function mapStateToProps(state) {
  return state;
};

export default connect(
  mapStateToProps,
  {
    push,
    loadFestivalSponsorshipCategories
  }
)(FestivalOurSponsors);



// WEBPACK FOOTER //
// ./src/containers/FestivalOurSponsors.jsx